export function rgbToHex(r, g, b) {
  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
}

export function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b
  })

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  } : null
}

/**
 * get known from
 * https://stackoverflow.com/questions/30143082/how-to-get-color-value-from-gradient-by-percentage-with-javascript/30144587
 * @param color1
 * @param color2
 * @param weight
 * @returns {*[]}
 */
export function mixColor(hexColor1, hexColor2, weight) {
  const color1 = hexToRgb(hexColor1)
  const color2 = hexToRgb(hexColor2)
  const w1 = weight
  const w2 = 1 - w1
  if (color1 && color1) {
    return {
      r: Math.round(color1.r * w1 + color2.r * w2),
      g: Math.round(color1.g * w1 + color2.g * w2),
      b: Math.round(color1.b * w1 + color2.b * w2),
    }
  }
}
